<script>
import _ from 'lodash'
import ToolbarActions from '@/components/ToolbarActions'
import MenuActions from '@/components/MenuActions'

export default {
  functional: true,
  components: {
    toolactions: ToolbarActions,
    toolmenus: MenuActions,
  },
  props: {
    selectAll: Function,
    selectNone: Function,
    count: Number,
    totalCount: Number,
    actions: Array,
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  render: (h, { props }) => {
    const { selectAll, selectNone, count, totalCount, actions, isLoading } = props
    let label = `${count} selectionnés / ${totalCount}`
    let inputValue = count === totalCount
    const doSelectAll = value => { selectAll() }
    const doSelectNone = event => { selectNone() }
    const barActions = _.reject(actions, {menu: true})
    const menuActions = _.filter(actions, {menu: true})

    const loader = isLoading
      ? <v-avatar>
        <v-progress-circular indeterminate/>
      </v-avatar>
      : null

    return (
      <v-toolbar fixed flat dense class="selection-tools elevation-10">

        <v-btn flat on-click={ doSelectNone }>
          <v-icon left>chevron_left</v-icon>
          Retour
        </v-btn>
        { loader }
        <v-spacer></v-spacer>
        <v-checkbox
          label={ label }
          hide-details
          on-change={ doSelectAll }
          input-value={ inputValue }
          indeterminate={ !inputValue }
        />

        <v-spacer></v-spacer>
        <ToolbarActions actions={ barActions } />

        <v-spacer></v-spacer>
        <MenuActions actions={ menuActions } />

      </v-toolbar>

    )
  },

}
</script>

<style>
.selection-tools {
  z-index: 99999 !important;
}
</style>
